export default __webpack_public_path__ + "static/media/legal-documents-payment.9acfa58b.svg";